export const appName = "pAIper";
